<template>
  <div class="mb35 p20 brdr-1 brdr-cl-primary bg-cl-white" style="border-radius: 30px;">
    <!-- My orders header -->
    <div class="row mb15">
      <div class="col-xs-12 col-sm-6">
        <h3 class="m0 mb5">
          {{ $t('My invoices') }}
        </h3>
      </div>
    </div>
    <!-- My orders body -->
    <div class="row">
      <div class="col-xs-12" v-show="!isInvoicesListEmpty">
        <table class="brdr-1 brdr-cl-bg-secondary">
          <thead>
            <tr>
              <th class="p20 sans-serif lh20">
                {{ $t('Invoice nr.') }}
              </th>
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('Create date') }}
              </th>
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('Payment term') }}
              </th>
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('Amount') }}
              </th>
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('Status') }}
              </th>
              <th class="p20 sans-serif lh20 hide-on-xs">
                {{ $t('Download link') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="brdr-top-1 brdr-cl-bg-secondary" v-for="invoice in invoices" :key="invoice.id">
              <td class="fs-medium lh25">
                {{ invoice.invoice_nr }}
              </td>
              <td class="fs-medium lh25 hide-on-xs">
                {{ invoice.created_at | date(null, storeView) }}
              </td>
              <td class="fs-medium lh25 hide-on-xs">
                {{ invoice.payment_term | date(null, storeView) }}
              </td>
              <td class="fs-medium lh25">
                {{ invoice.amount }}
              </td>
              <td class="fs-medium lh25 hide-on-xs">
               {{ invoice.main_status | capitalize }}
              </td>            
              <td class="fs-medium lh25 hide-on-xs">
                <a href="#" @click.prevent="downloadInvoice(invoice.id, invoice.invoice_nr)">{{ $t("Download") }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-xs-12 h4" v-show="isInvoicesListEmpty">
        <p>{{ $t('No invoices yet') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import UserInvoices from '@vue-storefront/core/modules/user/components/UserInvoices'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export default {
  mixins: [UserInvoices],
  computed: {
    storeView () {
      return currentStoreView()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-icon-hover: color(secondary, $colors-background);

table {
  border-collapse: collapse;
  width: 100%;

  th, td {
    text-align: left;
    padding: 20px;

    @media (max-width: 1199px) {
      padding: 10px;
    }

    @media (max-width: 767px) {
      text-align: center;
    }

    &.hide-on-xs {

      @media (max-width: 767px) {
        display: none;
      }

    }

  }

  i {
    vertical-align: middle;
  }

}

.dropdown {
  display: block;
  margin: -20px;
  padding: 20px;

  @media (max-width: 1199px) {
    margin: -10px;
    padding: 10px;
  }

  .dropdown-content {
    display: none;
    position: absolute;
    right: 0;
    top: 100%;
    width: 160px;
    z-index: 1;
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
  }

  a {
    opacity: .6;

    &:hover,
    &:focus {
      background-color: $color-icon-hover;
      opacity: 1;
    }

  }

  &:hover .dropdown-content {
    display: block;
  }

}

</style>
